import { IProductLineContent, ProductCardBadgePrice } from "client/products/types";

/** Matches StorefrontCollectionContent in catalog/types.py */
type StorefrontCollectionContent = {
  headline?: string;
  description?: string;
};

/** Matches catalog StorefrontCollectionKind */
export const StorefrontCollectionKind = {
  Brand: "BRAND",
  Rebate: "REBATE",
} as const;
export type StorefrontCollectionKind =
  (typeof StorefrontCollectionKind)[keyof typeof StorefrontCollectionKind];

/** Matches ClientStorefrontCollectionRebateSerializer */
export type StorefrontCollectionRebate = {
  id: number;
  rebate_id: number;
  brand: string;
  title: string;
  /** The rebate's offer, short enough for a chip ("$50 back"). */
  chip: string;
  /** Which price the offer comes off; a subscription offer shows the autoship icon. */
  applies_to: ProductCardBadgePrice;
  /** An authored link; null opens the rebate's terms. */
  url: string | null;
  /** Null for a rebate that applies without one. */
  promo_code: string | null;
  /** The last day the offer can be used, YYYY-MM-DD. */
  end_date: string | null;
};

/** Matches ClientStorefrontCollectionSerializer and ClientStorefrontDealSerializer */
export type StorefrontCollection = {
  id: number;
  slug: string;
  name: string;
  content: StorefrontCollectionContent;
  isi: string;
  /** Marketing blocks, authored on the collection or inherited from a single product line. */
  contents: IProductLineContent[];
  /**
   * The rebates shown as cards under the hero. Only the deals endpoint serializes this; empty
   * when a deals page highlights none.
   */
  rebate_highlights?: StorefrontCollectionRebate[];
  banner_image: string | null;
  show_filters: boolean;
};
